import {ChatBroadcastType, Company, User} from '../types/freshchat'

import { OnboardingEvents } from '../events';
import constants from '../config/constants'
import store from '../store'
import { useEmitter } from '../pmd/composition/useEmitter'

let userData:User;
let companyData:Company;
const localStorageKey = 'FCWidgetLastUpdatedTime';
const idleThreshold :number= 12 * 60 * 60 * 1000; // 12-hours -idle time
const checkIntervalTime:number = 1 * 60 * 60 * 1000; // 1hour time-interval to check the idle-time over or not
let lastUpdatedTime:number = Date.now();
const broadcastChannel = new BroadcastChannel('freshChatOptimizer');
let autoCloseTimeout:NodeJS.Timeout

// Add new interface for widget config
interface WidgetConfig {
  widgetType?: 'implementation' | 'trial' | 'botpressSupport' | 'prioritysupport';
  ooh_source?: string;
}

async function initFreshChat(config?: WidgetConfig): Promise<void> {
  return new Promise((resolve: () => void) => {


    // Base widget configuration
    const widgetConfig = {
      token: 'f89e9094-c42d-425f-8e0b-82dd575529c8',
      host: 'https://highlevel-team.freshchat.com',
      siteId: userData.id,
      // tags: ["prioritysupport"],//tags your defined in topic settings
      config: {
        headerProperty: {
          hideChatButton: true,
        },
        content: {
          headers: {
            csat_question: 'Did you have a positive experience with your Support Representative Today?',
            csat_yes_question: 'How would you rate your Support Representative Today?',
            csat_no_question: "How could we have helped better?",
            csat_thankyou: "Thanks for the feedback!",
            csat_rate_here: "How would you rate your support representative?"
          },
        },
      }
    }

    if(config?.widgetType === 'implementation') {
      widgetConfig['widgetUuid'] = constants.freshchat.successWidgetUUID
    }

    if(config?.widgetType === 'botpressSupport') {
      widgetConfig['widgetUuid'] = constants.freshchat.botpressWidgetUUID
    }

    if(config?.widgetType === 'prioritysupport') {
      widgetConfig['widgetUuid'] = constants.freshchat.prioritysupportWidgetUUID
    }

    // Add support type specific configuration
    // switch(config?.supportType) {
    //   case 'Zoom':
    //     widgetConfig.config.content.headers.title = 'Zoom Support Request'
    //     break;
    //   case 'Chat':
    //     widgetConfig.config.content.headers.title = 'Live Chat Support'
    //     break;
    //   case 'New Ticket':
    //     widgetConfig.config.content.headers.title = 'Create Support Ticket'
    //     break;
    // }

    // Initialize widget
    window.fcWidget.init(widgetConfig)

    // Set user properties
    window.fcWidget.setExternalId(userData.id)
    window.fcWidget.user.setFirstName(userData.name)
    window.fcWidget.user.setEmail(userData.email)


    const userProperties = {
      ...userData,
      ...companyData,
      firstName: userData.name, //user's first name
      // isPrioritySupport: config.isPriority,
      //    lastName: userData., //user's last name
      email: userData.email, //user's email address
	    phone: userData.phone, //phone number without country code	
      'Company_Id': companyData.id,	
      'Company_Name': companyData.name,	
      'Company_Email': companyData.email,	
      'Company_Creation_Date': companyData.created,	
      'status': companyData.status,
      'Company_Plan': companyData.activePlan,
      'Company_Stripe_ID': companyData.stripeId,
      'Relationship_ID':companyData.relationshipNumber,
      'priority': companyData.prioritySupport ? 3 : 1,
      'datePurchase': companyData.datePurchase,
      'daySincePurchase': companyData.daySincePurchase,
      'first_implementation_call_date': companyData.firstImplementationCallDate,
      'implementation_csr_1': companyData?.implementationCSR1||'',
      ooh_source: config?.ooh_source
    }

    // if(config?.widgetType !== 'implementation') {
    //   userProperties['Chosen_Channel'] = config?.userData.chosenChannel
    //   userProperties['supportType'] = config?.supportType
    // }

    if(config?.widgetType === 'implementation') {
      userProperties['Internal_Team_Selected'] = 'Implementation'
      userProperties['Current_Number_of_Subaccounts'] = companyData?.locationCount
      userProperties['KO_Completion_date'] = companyData?.firstCaptureCallDate
    }


    // Set additional properties
    window.fcWidget.user.setProperties(userProperties)

    // if(config?.widgetType !== 'implementation') {
    //   userProperties['Chosen_Channel'] = config?.userData.chosenChannel
    //   userProperties['supportType'] = config?.supportType
    // }

    if(config?.widgetType === 'implementation') {
      userProperties['Internal_Team_Selected'] = 'Implementation'
      userProperties['Current_Number_of_Subaccounts'] = companyData?.locationCount
      userProperties['KO_Completion_date'] = companyData?.firstCaptureCallDate
    }


    // Set additional properties
    window.fcWidget.user.setProperties(userProperties)

    window.fcWidget.on("message:received", () => {
      updateLastUpdatedTime()
     if(!window.fcWidget.isOpen()){
       if(companyData.prioritySupport) {
        setFreshChatWidgetTags(['prioritysupport'])
       }
       else {
        setFreshChatWidgetTags([])
       }
       openFreshChatWidget()
     }
    })

    window.fcWidget.on("widget:opened", function() {
        checkIdleTime()
        const emitter = useEmitter()
        emitter.emit(OnboardingEvents.FRESHCHAT_WIDGET_VISIBILITY, true);
        resolve();
      });
      
      window.fcWidget.on("widget:loaded", function() {
        openFreshChatWidget()
    });
    
    window.fcWidget.on("widget:closed", function() {
      // We are emitting the event to handle kickoff widget
      // as its position is directly infludence by this.
      // This event is handled in agency dashboard.
      const emitter = useEmitter()
      // emitter.emit(OnboardingEvents.WIDGET_POSITION_TOGGLE, false);
      emitter.emit(OnboardingEvents.FRESHCHAT_WIDGET_VISIBILITY, false);
      window.fcWidget.destroy()
    });
  })
}

function loadFreshchat(i: any, t: any) {
 return new Promise<void>((resolve) => {
  let e
  if (i.getElementById(t)) {
    resolve();
  } else {
    e = i.createElement('script');
    e.id = t;
    e.async = true;
    e.src = 'https://highlevel-team.freshchat.com/js/widget.js';
    e.onload = () => { resolve() };
    i.head.appendChild(e);
  }
 })
}
function setupFreshDesk() {
  window.fwSettings = {
    widget_id: 48000001416,
  }
  if ('function' != typeof window.FreshworksWidget) {
    const n = function(...args) {
      n.q.push(args)
    }
    n.q = [];
    window.FreshworksWidget = n;
  }
}
function initFreshDesk() {
  return new Promise<void>((resolve) => {
  if (window.FreshworksWidget) {
    window.FreshworksWidget('hide', 'launcher')
    window.FreshworksWidget('identify', 'ticketForm', {
      name: userData.name,
      email: userData.email,
    })
    window.FreshworksWidget('prefill', 'ticketForm', {
      priority: 2,
      custom_fields: {
        cf_highlevel_login_email: userData.email,
      },
    })
    window.FreshworksWidget('hide', 'ticketForm', ['priority'])
  }
  resolve()
})
}
function loadFreshdesk(i: any, t: any) {
 return new Promise<void>((resolve) => {
  let e
  if (i.getElementById(t)) {
    initFreshDesk().then(() => resolve());
  } else {
    setupFreshDesk();
    e = i.createElement('script');
    e.id = t;
    e.async = true;
    e.src = 'https://widget.freshworks.com/widgets/48000001416.js';
    e.onload = () => { initFreshDesk().then(() => resolve()) };
    i.head.appendChild(e);
  }
  })
}
export function loadFreshChatWidgetScript(){
  return new Promise<void>((resolve) => {
  Promise.all([ loadFreshchat(document, 'freshchat-js-sdk')]).then(()=>{
    resolve()
  })
})
}

export function loadFreshWorksWidgets(config) {

  return new Promise<void>((resolve) => {
    userData =  store.getters['freshchat/getUserData'];
    companyData =  store.getters['freshchat/getCompanyData'];
    Promise.all([loadFreshdesk(document, 'freshdesk-js-sdk'),initFreshChat(config)]).then(()=>resolve())
  })
}

export function openFreshChatWidget(){
  window.fcWidget.open()
  updateLastUpdatedTime()
}
export function setFreshChatWidgetTags(tags){
  window.fcWidget.setTags(tags)
}
export function destroyFreshchatWidget(){
  if (window.fcWidget?.isOpen()) {
    window.fcWidget.destroy();
    broadcastChannel.postMessage({ action: ChatBroadcastType.Close ,UpdatedTime: lastUpdatedTime});
  }
  localStorage.removeItem(localStorageKey);
}
// Logic managing idle timeout
function updateLastUpdatedTime() {
  lastUpdatedTime = Date.now()
  localStorage.setItem(localStorageKey, Date.now().toString());
}
function checkIdleTime() {
  const currentTime = Date.now();
  const idleTime = currentTime - lastUpdatedTime;
  if(window.fcWidget.isOpen()){
    if (idleTime > idleThreshold) {
      broadcastChannel.postMessage({ action: ChatBroadcastType.Check, lastUpdatedTime });
      const waitingTime = 5000
      autoCloseTimeout = setTimeout(() => {
        broadcastChannel.postMessage({ action: ChatBroadcastType.Close ,UpdatedTime: lastUpdatedTime});
        destroyFreshchatWidget();
      }, waitingTime);
    } else {
        setTimeout(checkIdleTime, checkIntervalTime);
    }
  }
}
broadcastChannel.onmessage = (event) => {
  const { action,UpdatedTime } = event.data;
  if (action === ChatBroadcastType.Check) {
    const idleTime = Date.now() - lastUpdatedTime;
    const thresHold:number = 1 * 60 * 60 * 1000; // check any new chat initialize within one hour
    if (idleTime <= thresHold) {
       broadcastChannel.postMessage({ action: ChatBroadcastType.Cancel ,UpdatedTime: lastUpdatedTime});
    }
  }
  else if(action === ChatBroadcastType.Cancel){
    clearTimeout(autoCloseTimeout);
    lastUpdatedTime = UpdatedTime;
    checkIdleTime()
  }
  else if(action===ChatBroadcastType.Close){
    if(window.fcWidget.isOpen()){
      destroyFreshchatWidget();
    }
  }
}